import React                       from 'react';
import {Avatar, Button, Card} from "antd";
import {Image, Modal, Result, Space} from "antd";
import {useTranslation}            from "react-i18next";
import useEnvironment              from "@hooks/useEnvironment";
import locale                      from "../localization/locale";

const DriverLogin = (props) => {
   const {cbLogout, appsVersion} = props;
    const {t} = useTranslation();
    const [,get_s3_url] = useEnvironment();
    return (
        <Modal
            centered={true}
            closable={false}
            maskClosable={false}
            title={null}
            footer={<Button key={2} type="primary" onClick={cbLogout}>
                {t("lookup.fuel_history.action.logout")}
            </Button>}
            visible={true}
        >
            <Result
                title={t("sellerLogin.title")}
                subTitle={t("sellerLogin.description")}
                extra={<Space direction="vertical">
                    {(appsVersion || []).filter(item => item.name === "Fuel2go Validator").map(item => {
                        return <a key={item._id} href={get_s3_url(item.file)} target={"_blank"} rel="noreferrer">
                            <Card.Meta
                                style={{cursor: "pointer", border: "solid 1px #808080", borderRadius: 6, padding: 10}}
                                avatar={<Avatar src={"/images/fm_logo.svg"}/>}
                                title={<div style={{display: "flex"}}>
                                    <span style={{flex: "1 1 auto", paddingRight: 5}}>{locale.get("mobile_app.download")} {item.name}</span>{item.os === "android" &&
                                    <Image src="/images/google-play-logo.webp" width={100}/>}
                                </div>}
                                description={`${locale.get("mobile_app.version")}: ${item.current}`}
                            />
                        </a>;
                    })}
                </Space>
            }/>
        </Modal>
    )
};

export default DriverLogin;
